import { getTheme } from '@Thread-Magic/jasmine';
import { theme } from 'antd';

export default function customTheme(themeMode) {
  const algorithm = themeMode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm;

  return {
    colorPrimary: getTheme().colors.brand.light.base,
    algorithm,
    components: {
      Button: {
        colorPrimary: getTheme().colors.brand.light.base,
        algorithm: true
      },
      DatePicker: {
        colorPrimary: getTheme().colors.brand.light.base,
        colorLink: getTheme().colors.brand.light.base,
        algorithm: true
      },
      Select: {
        colorPrimary: getTheme().colors.brand.light.base,
        algorithm: true
      }
    }
  };
}
